import { createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { startOfMonth, subMonths } from "date-fns";
import moment from "moment";

import { stateDate } from "../../../../utils/formatDate";
import { IExpiredReportOptions } from "../../../../types/reportsInterfaces";

const initialState: any = {
  reports: null,
  reportsCount: null,
  limit: JSON.parse(localStorage.getItem("pageLimit") as string) || 10,
  page: 1,
  expiredRecordsModalCreateValues: {
    projects: [],
    merchs: [],
    svs: [],
    vsv: [],
  },
  expiredReportsFilters: {
    projects: [],
    merchs: [],
    svs: [],
    vsv: [],
  },
  expiredReportsInputValues: {
    fromDate: stateDate(startOfMonth(subMonths(new Date(), 1))),
    toDate: stateDate(new Date()),
    address: null,
    contracts: [],
    statuses: [],
    projects: [],
    merchs: [],
    chains: [],
    svs: [],
  },
  formattedDateFrom: moment(
    stateDate(startOfMonth(subMonths(new Date(), 1)))
  ).format("DD/MM/YYYY"),
  formattedDateTo: moment(stateDate(new Date())).format("DD/MM/YYYY"),
  expiredReportsSettings: JSON.parse(
    localStorage.getItem("selectedExpiredReportsTabs") as string
  ) || [
    "date",
    "contract",
    "chain",
    "address",
    "project",
    "sv",
    "coordinator",
    "merchRoutes",
    "merchStatus",
  ],
};

export const reportsSlice = createSlice({
  name: "expiredReports",
  initialState,
  reducers: {
    reducerExpiredReports: (state: Draft<any>, action: PayloadAction<any>) => {
      state.reports = action.payload.data.data || [];
      state.expiredReportsCount = action.payload.data.count;
      state.limit = action.payload.limit;
      state.page = action.payload.page;
      state.checkboxes = action.payload.data.data?.reduce(
        (acc: boolean[], report: IExpiredReportOptions) => {
          acc[report.expiredReport.id] = false;
          return acc;
        },
        {}
      );
    },
    reducerDeletedExpiredReports: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.reportsId = action.payload;
    },
    reducerExpiredReportsInputValues: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.expiredReportsInputValues = {
        ...state.expiredReportsInputValues,
        ...action.payload,
      };
      state.formattedDateFrom = action.payload.fromDate ? moment(action.payload.fromDate).format(
        "DD/MM/YYYY"
      ) : state.formattedDateFrom;
      state.formattedDateTo = moment(action.payload.toDate).format(
        "DD/MM/YYYY"
      );
    },
    reducerExpiredRecordsModalCreateValues: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.expiredRecordsModalCreateValues = {
        ...state.expiredRecordsModalCreateValues,
        ...action.payload,
      };
    },
    reducerGetFiltersExpiredReports: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.expiredReportsFilters = {
        ...state.expiredReportsFilters,
        ...action.payload,
      };
    },
    reducerExpiredReportsStatus: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.status = action?.payload?.status;
      state.requestPurpose = action?.payload?.requestPurpose;
    },
    reducerExpiredReportsSettings: (
      state: Draft<any>,
      action: PayloadAction<any>
    ) => {
      state.expiredReportsSettings = action.payload;
    },
    reducerExpiredReportsClearInputValues: () => {
      return initialState;
    },
  },
});

export const {
  reducerExpiredReportsClearInputValues,
  reducerExpiredReportsInputValues,
  reducerExpiredReportsSettings,
  reducerExpiredRecordsModalCreateValues,
  reducerDeletedExpiredReports,
  reducerExpiredReportsStatus,
  reducerExpiredReports,
  reducerGetFiltersExpiredReports,
} = reportsSlice.actions;

export default reportsSlice.reducer;
